module.exports = __webpack_public_path__ + "static/media/27.6c19ed44.mp3";